import React, { FunctionComponent, PropsWithChildren, ReactNode } from "react";

import { WebtieWordmark } from "../common/WebtieWordmark";

interface Props extends PropsWithChildren {
  title: string;
  lead: string;
  /** Hinweise und Querverweise unterhalb des Formulars. */
  footer: ReactNode;
}

export const AuthLayout: FunctionComponent<Props> = ({ title, lead, footer, children }) => (
  <div className="auth-page">
    <div className="auth-card">
      <WebtieWordmark size={64} className="auth-card__logo" />
      <h1 className="auth-card__title">{title}</h1>
      <p className="auth-card__lead">{lead}</p>
      {children}
      <div className="auth-card__foot">{footer}</div>
    </div>
    <p className="auth-page__note">Spielgruppe Online — Anmeldungen einfach verwalten</p>
  </div>
);
